"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithDefaultValue = void 0;
var class_transformer_1 = require("class-transformer");
function WithDefaultValue(defaultValue, options) {
    if (!options) {
        options = { toClassOnly: true };
    }
    else if (options.always) {
        delete options.toClassOnly;
        delete options.toPlainOnly;
    }
    else if (!('toClassOnly' in options) && !('toPlainOnly' in options)) {
        options.toClassOnly = true;
    }
    return (0, class_transformer_1.Transform)(function (_a) {
        var value = _a.value, options = _a.options, type = _a.type;
        if (value === undefined && options.excludeDefaultValues) {
            return value;
        }
        if (typeof defaultValue === 'function') {
            defaultValue = defaultValue();
        }
        return value === undefined ? defaultValue : value;
    }, options);
}
exports.WithDefaultValue = WithDefaultValue;
//# sourceMappingURL=with-default-value.js.map